type Props = {
    text: string | JSX.Element
}
export function BolderText({ text }: Props) {
    return <span className="font-semibold">{ text }</span>
}